import { render, staticRenderFns } from "./useServeInfoDialog.vue?vue&type=template&id=91089f04&scoped=true&"
import script from "./useServeInfoDialog.vue?vue&type=script&lang=js&"
export * from "./useServeInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./useServeInfoDialog.vue?vue&type=style&index=0&id=91089f04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91089f04",
  null
  
)

export default component.exports